<template>
  <div>
    <div id="designerButtonContainer">
      <vs-button color="primary" type="filled" @click="toggleSettingsSideBar()">Settings</vs-button>
      <vs-button color="success" @click="run()" type="filled">Run</vs-button>
      <vs-button color="warning" @click="save()" type="filled">Save</vs-button>
    </div>
    <vs-button id="deleteButton" radius color="danger" type="filled" icon="delete_outline" @click="deleteClik()"></vs-button>
  </div>
</template>

<script>

export default {
  data () {
    return {
      request_config: {
        headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
      }
    }
  },
  methods: {
    toggleSettingsSideBar () {
      this.$emit('toggleSettingsSideBar')
    },
    run () {
      this.$emit('run')
    },
    save () {
      this.$emit('save')
    },
    deleteClik () {
      this.$vs.dialog({
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this clik?',
        accept: () => {
          this.$emit('delete')
        }
      })
    }
  }
}
</script>
<style>
#designerButtonContainer {
 position: absolute;
 bottom: 20px;
 width: 100%;
 text-align: center;
}
#designerButtonContainer > .vs-button {
  margin-left: 20px;
}
#deleteButton {
  position:fixed;
  right:0;
  bottom:0;
  margin-right: 30px;
  margin-bottom: 15px;
}
</style>
